<div id="map-options-menu">
  <div role="radiogroup" aria-label="Map style" (keydown)="onLayerArrowKey($event)">
    <div id="classic-layer-selector"
      [class.border-selected]="classicLayerSelected"
      class="classic"
      [attr.tabindex]="activeLayerIndex === 0 ? 0 : -1"
      role="radio"
      [attr.aria-checked]="classicLayerSelected"
      (focus)="activeLayerIndex = 0"
      (click)="onLayerClick('NORMAL_DAY')"
      (keydown.enter)="onLayerClick('NORMAL_DAY')"
      (keydown.space)="onLayerClick('NORMAL_DAY'); $event.preventDefault()">
        <span>
          {{ translateService.get(translations.map.layersControl.classicMap) | async | translate }}
        </span>
    </div>

    <div id="satellite-layer-selector"
      [class.border-selected]="satelliteLayerSelected"
      class="satellite"
      [attr.tabindex]="activeLayerIndex === 1 ? 0 : -1"
      role="radio"
      [attr.aria-checked]="satelliteLayerSelected"
      (focus)="activeLayerIndex = 1"
      (click)="onLayerClick('HYBRID_DAY')"
      (keydown.enter)="onLayerClick('HYBRID_DAY')"
      (keydown.space)="onLayerClick('HYBRID_DAY'); $event.preventDefault()">
        <span>
          {{ translateService.get(translations.map.layersControl.satellite) | async | translate }}
        </span>
    </div>
  </div>
  <section *ngIf="checkboxesVisible" class="checkboxes"
    (keydown.enter)="onCheckboxEnter($event)">
    <ul>
      <li><mat-checkbox class="cypress-cluster-toggle" [checked]="clusterEnabled" (change)="onClusterAssetsClick($event)">
        {{ translateService.get(translations.map.checkboxOptions.clusterAssets) | async | translate }}
      </mat-checkbox></li>
      <li><mat-checkbox class="cypress-incident-toggle" [checked]="incidentsEnabled" (change)="onRoadIncidentsClick($event)">
        {{ translateService.get(translations.map.checkboxOptions.roadIncidents) | async | translate }}
      </mat-checkbox></li>
      <li><mat-checkbox class="cypress-traffic-toggle" [checked]="trafficEnabled" (change)="onTrafficClick($event)">
        {{ translateService.get(translations.map.checkboxOptions.traffic) | async | translate }}
      </mat-checkbox></li>
      <li><mat-checkbox id="pendo_gtcx_zone_checkbox" class="cypress-show-zones-toggle" [checked]="zonesEnabled" (change)="onShowZonesClick($event)">
        {{ translateService.get(translations.map.checkboxOptions.showZones) | async | translate }}
      </mat-checkbox></li>
      <li *ngFor="let layer of weatherLayers">
        <mat-checkbox [checked]="layer.enabled" (change)="onWeatherLayerChange($event, layer)">
          {{ layer.label }}
        </mat-checkbox>
      </li>
    </ul>
  </section>
</div>
